import { Col, Form as FormInicial, message, Row, Tag } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    FormItem,
    InputNumberItem,
    ModalItem,
    ButtonItem,
    ErrorItem,
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";

class ElegirLotesCliente extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        lotes: [],
        insumo: null,
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.consultarLotesRestantes()
        }
    }

    cerrarElegirLotesCliente(agregar) {
        if (agregar) {
            this.setState({ loading: true });
            const lotes = this.formRef.current.getFieldValue('lotes')
            const lotesFiltrados = lotes && Array.isArray(lotes) ? lotes.filter(lote => lote.cantidadRequerida && lote?.cantidadRequerida > 0) : []
            axios
                .post(
                    "lotes/agregarLotesAVenta",
                    { empresaId: this.props.empresaId, lotes: lotesFiltrados },
                    {
                        headers: this.props.headersToken,
                    }
                )
                .then((res) => {
                    if (res.data.success === 2) {
                        this.props.cerrarElegirLotesCliente(res.data.insumosAgregar);
                        this.formRef.current.resetFields()
                    } else if (res.data.success === 1) {
                        message.warning(res.data.message)
                    } else {
                        message.error('Hubo un error y no se pudieron agregar los lotes')
                    }
                    this.setState({ loading: false });
                });
        } else {
            this.props.cerrarElegirLotesCliente([]);
            this.formRef.current.resetFields()
        }
    }

    async consultarLotesRestantes() {
        this.setState({ loading: true });
        await axios
            .post(
                "lotes/selectLotesDisponiblesCliente",
                {
                    empresaId: this.props.empresaId,
                    proyectoId: this.props.proyectoId,
                    clienteId: this.props.clienteId
                },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    const nuevosLotes = res.data.lotesDisponibles.map(valeuLote => {
                        const loteCatual = this.props?.lotes ? this.props?.lotes?.find(valueTM => valueTM._id.toString() === valeuLote._id.toString()) : undefined
                        return {
                            ...valeuLote,
                            cantidadRequerida: loteCatual?.cantidadRequerida || 0
                        }
                    })
                    this.setState({ lotes: nuevosLotes, insumo: res.data.insumo });
                    this.formRef.current.setFieldsValue({
                        lotes: nuevosLotes
                    })
                } else if (res.data.success === 1) {
                    message.warning(res.data.message)
                } else {
                    message.error('Hubo un error y no se pudo consultar los lotes disponibles')
                }
            });
        this.setState({ loading: false });
    }

    onFinish() {
        this.cerrarElegirLotesCliente(true)
    }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    render() {
        return (
            <>
                <ModalItem
                    title="Elegir Lotes Cliente"
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={() => this.cerrarElegirLotesCliente(false)}
                    paddingTop
                    width={1200}
                >
                    <Form
                        ref={this.formRef}
                        name="elegirLotesCliente"
                        layout
                        bottom={
                            <ButtonItem
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Elegir
                            </ButtonItem>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <FormInicial.List name="lotes">
                            {(fields) => (
                                <>
                                    <table className="table">
                                        {fields.length > 0 ? (
                                            <thead>
                                                <tr>
                                                    <th className="th-border" style={{ width: "10%" }}>
                                                        Numero
                                                    </th>
                                                    <th className="th-border" style={{ width: "20%" }}>
                                                        Insumo
                                                    </th>
                                                    <th className="th-border" style={{ width: "10%" }}>
                                                        Fecha
                                                    </th>
                                                    <th className="th-border" style={{ width: "20%" }}>
                                                        Cliente
                                                    </th>
                                                    <th className="th-border" style={{ width: "15%" }}>
                                                        Etapa
                                                    </th>
                                                    {this.state.insumo?.vehiculo ? (
                                                        <>
                                                            <th className="th-border" style={{ width: "10%" }}>
                                                                Color
                                                            </th>
                                                            <th className="th-border" style={{ width: "10%" }}>
                                                                Niv
                                                            </th>
                                                        </>
                                                    ) : null}
                                                    <th className="th-border" style={{ width: "7.5%" }}>
                                                        Disp.
                                                    </th>
                                                    <th className="th-border" style={{ width: "7.5%" }}>
                                                        Requerir
                                                    </th>
                                                </tr>
                                            </thead>
                                        ) : null}
                                        {fields.map(({ key, name, fieldKey, ...restField }, arrayKey) => (
                                            <tbody key={arrayKey}>
                                                <tr>
                                                    <td className="td-border">
                                                        <p style={{ margin: 0, marginLeft: 10 }}>{this.state.lotes[arrayKey].numero}</p>
                                                    </td>
                                                    <td className="td-border">
                                                        <p style={{ margin: 0, marginLeft: 10 }}>{this.state.lotes[arrayKey].insumoNombre}</p>
                                                    </td>
                                                    <td className="td-border">
                                                        <p style={{ margin: 0, marginLeft: 10, textAlign: "center" }}>{moment(this.state.lotes[arrayKey].createdAt).locale("es").format("DD/MM/YYYY")}</p>
                                                    </td>
                                                    <td className="td-border">
                                                        <p style={{ margin: 0, marginLeft: 10 }}>{this.state.lotes[arrayKey].clienteNombre}</p>
                                                    </td>
                                                    <td className="td-border-center">
                                                        <Tag color="blue">{this.state.lotes[arrayKey].etapa}</Tag>
                                                    </td>
                                                    {this.state.insumo?.vehiculo ? (
                                                        <>
                                                            <td className="td-border">
                                                                <p style={{ margin: 0, marginLeft: 10 }}>{this.state.lotes[arrayKey]?.color}</p>
                                                            </td>
                                                            <td className="td-border">
                                                                <p style={{ margin: 0, marginLeft: 10 }}>{this.state.lotes[arrayKey]?.niv}</p>
                                                            </td>
                                                        </>
                                                    ) : null}
                                                    <td className="td-border">
                                                        <p style={{ margin: 0, marginLeft: 10 }}>{this.state.lotes[arrayKey].saldo}</p>
                                                    </td>
                                                    <td className="td-border">
                                                        <FormItem
                                                            noStyle
                                                            shouldUpdate={(prev, curr) =>
                                                                prev.lotes !==
                                                                curr.lotes
                                                            }
                                                        >
                                                            {({ getFieldValue }) => {
                                                                const lotes = getFieldValue("lotes");
                                                                const max = lotes[arrayKey].saldo;
                                                                return (
                                                                    <Row>
                                                                        <Col span={4}>
                                                                            <ButtonItem
                                                                                type="primary"
                                                                                onClick={() => {
                                                                                    const updatedLotes = [...lotes];
                                                                                    updatedLotes[arrayKey].cantidadRequerida = max;
                                                                                    this.formRef.current.setFieldsValue({ lotes: updatedLotes });
                                                                                }}
                                                                                icon="T"
                                                                                style={{ width: "100%" }}
                                                                            />
                                                                        </Col>
                                                                        <Col span={20}>
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "cantidadRequerida"]}
                                                                                numberCero
                                                                                noStyle
                                                                                type="number"
                                                                                max={max}
                                                                            >
                                                                                <InputNumberItem
                                                                                    sinBorde
                                                                                    placeholder={
                                                                                        max && max !== Infinity
                                                                                            ? "Max: " + max
                                                                                            : "Cantidad"
                                                                                    }
                                                                                />
                                                                            </FormItem>
                                                                        </Col>
                                                                    </Row>
                                                                );
                                                            }}
                                                        </FormItem>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        )
                                        )}
                                    </table>

                                </>
                            )}
                        </FormInicial.List>
                    </Form>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(ElegirLotesCliente);
